export default __webpack_public_path__ + "static/media/Logo.19472383.svg";